<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-sm-6 offset-sm-3">
              <div class=" row">
                <div class="col-12 text-center">
                  <h1>Recuperación de contraseña</h1>
                </div>
              </div>
              <div class="row">
                <div class="formulario col-12 bgblanco rounded pt-3 pb-4">
                  <div class="col-12 pb-2 text-center">
                    Ingresa el correo electrónico registrado de tu cuenta y te enviaremos un correo para recuperar tu contraseña.
                  </div>
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <input
                        type="email"
                        v-model="email"
                        maxlength="100"
                        placeholder="Email"
                        class="text-center"
                        pattern="[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}"
                        required
                      />
                    </label>

                    <div class="text-center pt-2">
                      <button type="submit" class="submit btnnaranja">
                        ENVIAR
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row p-1">
                <div class="col-12 text-center">
                  <router-link class="link" to="/"
                    >Regresar al login</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div class="container">
          <div class="row p-2">
            <div class="col-12 text-center">
              <div class="texto">
                <span class="px-1">
                  GAIG
                  <sup>&reg;</sup> 2021. {{version}}
                </span>

                
                
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      tiposervicio: "",
      version: ""
    };
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    this.version = this.$store.state.version;
    AOS.init();
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.email
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "olvido.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];

              this.email = "";

              swal
                .fire({
                  title: "Recuperación de contraseña",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push("/");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      //this.$router.push("/");
    },
  },
};
</script>

